const data = {
    "Search Trips": "Buscar Viaje",
    "Enter Trip Number": "Ingrese el número de viaje",
    "Trip Number": "Número de viaje",
    "Search Organization": "Buscar Organización",
    "Enter Organization Name": "Ingrese el nombre de la organización",
    "Filter by": "Filtrar por",
    "Customs Border": "Frontera Aduanal",
    "Trip Type": "Tipo de Viaje",
    "All Carriers": "Transportistas",
    "All Ports": "Puertos",
    "Trip Status": "Estatus",
    "Pending": "Pendientes",
    "Dispatch": "Despachados",
    "Ready for Dispatch": "Listo para Despacharse",
    "Awaiting Customs": "En espera de Aduana",
    "In Transit": "En tránsito",
    "Released": "Liberado",
    "Sent": "Enviado",
    "Accepted": "Aceptado",
    "Rejected": "Rechazado",
    "Deleted": "Eliminado",
    "Arrived": "Arribado",
    "Draft": "Borrador",
    "Active": "Activos",
    "Archived": "Archivados",
    "Cancel": "Cancelar",
    "Close": "Cerrar",
    "Trip": "Viaje",
    "Trips": "Viajes",
    "Trip #": "No. Viaje",
    "New Trip": "Nuevo Viaje",
    "Save Trip": "Guardar Viaje",
    "Dashboard": "Inicio",
    "Catalogs": "Catálogos",
    "Account Settings": "Configuración de Cuenta",
    "Member Settings": "Configuración de Cuenta",
    "Profile": "Perfil",
    "Notifications": "Notificaciones",
    "Basic Information": "Información Básica",
    "Sign out": "Salir",
    "First Name": "Nombre",
    "Last Name": "Apellido",
    "Phone Number": "Teléfono",
    "Update Profile": "Actualizar Perfil",
    "Email Address": "Correo Electrónico",
    "Reset Password": "Restablecer Contraseña",
    "Check your Inbox": "Revise su bandeja de entrada",
    "Enter a valid email address": "introduzca un Correo Electrónico válido",
    "Optima Commerce is the leading E-manifest solution provider for US & Canada.": "Optima Commerce es el proveedor lider de soluciones E-manifest para EE.UU y Canadá.",
    "Email is required": "Correo Electrónico obligatorio",
    "Text Password Reset": `Enviaremos las instrucciones del reinicio de contraseña a su correo electrónico. Si no recibe el correo dentro de 10 minutos, revise su carpeta se spam o intente de nuevo.`,
    "Registered email address": "Correo Electrónico registrado",
    "email is a required field": "Correo Electrónico obligatorio",
    "First Name is a required field": "Nombre obligatorio",
    "Name is a required field": "Nombre obligatorio",
    "Last Name is a required field": "Apellido(s) obligatorio(s)",
    "Organization Name is a required field": "Nombre de organización obligatorio",
    "Phone Number is a required field": "Número de teléfono obligatorio",
    "VIN is a required field": "Número de serie es obligatorio",
    "Must have at least 8 characters": "Debe contener al menos 8 caracteres",
    "Organization Name must be at least 3 characters": "Nombre de Organización debe ser de al menos 3 caracteres",
    "We've sent password reset instructions to your email address. If no email is received within ten minutes, check that the submitted address is correct.": "Enviamos las instrucciones para restablecer su contraseña a tu correo electrónico. Si no recibe el correo dentro de 10 minutos, revise que el correo ingresado es el correcto",
    "Today": "Hoy",
    "This Week": "Esta semana",
    "This Month": "Este mes",
    "Phone number must be exactly 10 numbers": "Número de teléfono debe ser de 10 dígitos",
    "Page": "Página",
    "to": "a",
    "of": "de",
    "or": "o",
    "No rows to show": "Sin filas para mostrar",
    "No options to show": "Sin opciones para mostrar",
    "No commodities to show": "Sin mercancías para mostrar",
    "Drag n’ Drop your CSV file here": "Arrastre y suelte su archivo CSV aquí",
    "browse file": "Buscar archivo",
    "Don't have a template": "No tiene plantilla",
    "Download here": "Descargar aquí",
    "accepted": "Aceptado",
    "uploading": "Cargando",
    "Bulk upload": "Carga masiva",
    "Reports": "Reportes",
    "Equipment": "Equipo",
    "Port": "Puerto",
    "Download CSV": "Descargar CSV",
    //Catalogs Menu
    "Organization": "Organización",
    "Parties": "Empresas",
    "Commodities": "Mercancías",
    "Carriers": "Transportistas",
    "Select Carrier": "Seleccione Transportista",
    "Find Carrier": "Buscar Transportista",
    "Conveyances": "Vehículos",
    "Conveyance": "Vehículo",
    "Equipments": "Equipos",
    "Drivers": "Chofer",
    "Passengers": "Pasajeros",
    "Passenger": "Pasajero",
    //Parties
    "New Party": "Nueva Empresa",
    "Info": "Información",
    "Name": "Nombre",
    "Phone": "Teléfono",
    "Address": "Dirección",
    "Postal Code": "Código Postal",
    "Country": "País",
    "Select": "Seleccione",
    "State": "Estado",
    "City": "Ciudad",
    "Shipper": "Exportador",
    "Contact": "Contacto",
    "Email": "Correo Electrónico",
    "Consignee": "Consignatario",
    "Required fields": "Campos obligatorios",
    "Party": "Empresa",
    "New": "Agregar",
    "Enabled": "Activo",
    "Disabled": "Inactivo",
    "Save": "Guardar",
    "Delete": "Eliminar",
    "Commodity Description": "Descripción de la Mercancía",
    "Quantity": "Cantidad",
    "Quantity UOM": "Unidad de Cantidad UDM",
    "Commodity Code": "Código de Mercancía",
    "Gross Weight": "Peso Bruto",
    "Weight UOM": "Unidad Peso",
    "Hazmat Info": "Información de Permiso Hazmat",
    "Hazmat Class": "Clase HM",
    "Hazmat UN Code": "Código Hazmat",
    "Additional Info": "Información Adicional",
    "HTS": "HTS (Sistema de Tarifas Armonizadas)",
    "Value": "Valor",
    "Commodity": "Mercancía",
    "Marks And Numbers": "Números y Marcas",
    "Owner": "Dueño",
    "Physical Address Info": "Información de Dirección Física",
    "Contact Information": "Información de Contacto",
    //Carriers
    "Carriers": "Transportistas",
    "Carrier": "Transportista",
    "Carrier Name": "Nombre del Transportista",
    "SCAC": "SCAC",
    "Canadian SCAC": "SCAC Canada",
    "Dot Number": "Número DOT",
    "Federal Tax ID": "ID Fiscal",
    "Location": "Ubicación",
    "Physical Address": "Dirección Física",
    "Permissions": "Permisos",
    "Allow Conveyance change": "Permitir cambios en vehículos",
    "Allow Equipment change": "Permitir cambios en equipos",
    "Allow Driver change": "Permitir cambios en choféres",
    "Search Organization": "Buscar Organización",
    "Allowed Organizations": "Organizaciones Autorizadas",
    "Carrier is a required field": "Transportista obligatorio",
    "scac is a required field": "scac obligatorio",
    "Dot Number is a required field": "Número DOT obligatorio",
    "Carrier Code Text": "Se requiere SCAC o SCAC canadiense.",
    "At least SCAC or CASCAC is required": "Se requiere al menos SCAC o SCAC canadiense",
    //Conveyance
    "Type": "Tipo",
    "Select Type": "Seleccione Tipo",
    "Conveyance Number": "Número del Vehículo",
    "Primary Plate": "Placa Primaria",
    "VIN": "Número de Serie",
    "Settings": "Configuración",
    "Organization Settings": "Configuración de Organización",
    "Default Driver": "Chofer por Defecto",
    "Default Equipment(s)": "Equipo por Defecto",
    "Secondary Info": "Información Secundaria",
    "Make": "Marca",
    "Model Year": "Año del Modelo",
    "Style": "Estilo",
    "Secondary Plate": "Placa Secundaria",
    "Secondary Plate Country": "País de Placa Secundaria",
    "Tracking IMEI": "Rastreador IMEI",
    "Insurer": "Asegurador",
    "Insurance": "Asegurador",
    "Insurance Info": "Información de Asegurador",
    "Policy Insurance": "Póliza de Seguros",
    "Policy Number": "Número de Póliza",
    "Policy Issue Date": "Fecha de emisión de Póliza",
    "Coverage Amount": "Monto de Cobertura",
    "Search": "Buscar",
    "Conveyance Type is a required field": "Tipo del vehículo obligatorio",
    "Conveyance Number is a required field": "Número del vehículo obligatorio",
    "Primary Plate is a required field": "Placa primaria obligatoria",
    "Primary Plate Country is a required field": "País de la placa primaria obligatorio",
    //Equipment
    "Equipment": "Equipo",
    "Equipment Type": "Tipo de Equipo",
    "Equipment Number": "Número de Equipo",
    "Leased": "Arrendado",
    "Equipment Type is a required field": "Tipo de equipo obligatorio",
    "Equipment Number is a required field": "Número de equipo obligatorio",
    "Select country": "Seleccione país",
    "Select State": "Seleccione estado",
    "Select state": "Seleccione estado",
    "Select Make": "Seleccione marca",
    "Select Secondary Plate Country": "Seleccione país de placa secundaria",
    //Drivers
    "Driver": "Chofer",
    "Middle Name": "Segundo Nombre",
    "Date of Birth": "Fecha de Nacimiento",
    "Gender": "Género",
    "Male": "Hombre",
    "Female": "Mujer",
    "Citizenship": "Ciudadanía",
    "License Number": "Número de Licencia",
    "License Country": "País de Licencia",
    "License State/Province": "Estado de la Licencia",
    "Location Code": "Código de Ubicación",
    "Reference": "Referencia",
    "Travel Documents": "Documentos de Viaje",
    "Travel Doc Text": "Al menos un Documento de Viaje es Obligatorio.",
    "Passport": "Pasaporte",
    "Passport Country": "País de Pasaporte",
    "FAST": "Número de tarjeta FAST",
    "Border Crossing": "Zona Fronteriza",
    "Border Crossing Card": "Número de zona fronteriza",
    "Permanent Resident": "Residencia Permanente",
    "NEXUS": "Número NEXUS",
    "Passport Card": "Tarjeta de Pasaporte",
    "Enhanced Driver's License": "Licencia de Conducir Ampliada",
    "US Visa": "Número de Visa",
    "Contact Info": "Información de Contacto",
    "Date of Birth is a required field": "Fecha de nacimiento obligatoria",
    "Citizenship is a required field": "Ciudadanía obligatoria",
    "License Number is a required field": "Número de licencia obligatorio",
    "License Country is a required field": "País de licencia obligatorio",
    "License State is a required field": "Estado de licencia obligatoiro",
    "Travel Document": "Documento de viaje",
    "Select travel document": "Seleccione documento de viaje",
    "Add another document": "Agregar un documento",
    "At least one travel document is required": "Al menos un documento de viaje es obligatorio",
    "Travel document selection cannot be empty": "Al menos un documento de viaje es obligatorio",
    "Passport Country is required if passport is selected": "País de pasaporte es obligatorio si se selecciona pasaporte",
    "Passport Number is required if passport is selected": "Número de pasaporte es obligatorio si se selecciona pasaporte",
    "FAST Card Number is required if FAST is selected": "Número de tarjeta FAST es obligatorio si se selecciona FAST",
    "Border Crossing Card Number is required if Border Crossing Card is selected": "Número de zona fronteriza es obligatorio si se selecciona zona fronteriza",
    "Permanent Resident Card Number is required if Permanent Resident Card is selected": "Número de tarjeta de residencia permanente es obligatorio si se selecciona residencia permanente",
    "NEXUS is required if NEXUS is selected": "NEXUS es obligatorio si se selecciona NEXUS",
    "Enhanced License is required if Enhanced License is selected": "Licencia de conducir ampliada es obligatoria si se selecciona licencia de conducir ampliada",
    "US Visa Number is required if US Visa is selected": "Número de visa es obligatorio si se selecciona visa",
    "Hazmat Contact Info": "Información de contacto Hazmat",
    "Hazmat Contact Name": "Nombre de contacto Hazmat",
    "Hazmat Contact Phone": "Teléfono de contacto Hazmat",
    "Hazmat Contact Email": "Correo de contacto Hazmat",
    //Passenger
    "Passengers": "Pasajeros",
    //Trip
    "Trip Info": "Información de Viaje",
    "Trip Information": "Información de Viaje",
    "Estimated Arrival": "Fecha de Arribo",
    "Arrival Port": "Puerto de Arribo",
    "Enter Arrival port name or code": "Ingrese puerto de arribo o código",
    "Carrier Information": "Información de Transportista",
    "Optional Information": "Información Opcional",
    "Add": "Agregar",
    "Enter Conveyance name": "Ingrese Nombre de Vehículo",
    "Enter Equipment name": "Ingrese Nombre de Equipo",
    "Enter Driver name": "Ingrese Nombre de Chofer",
    "Generate": "Generar",
    "Enter Carrier name": "Ingrese Nombre de Carrier",
    "Enter port name or code": "Ingrese Nombre de Puerto o código",
    "Trip check data": "El Viaje no se pudo guardar, revise que información es requerida o incorrecta",
    "No shipments added": "No se han agregado embarques",
    "Add Shipments": "Agregar Embarques",
    "Select carrier first": "Seleccione un Carrier",
    "Import Shipments from CSV": "Importar Embarques desde CSV",
    "Add shipments text": "Puede agregar todos los embarques que requiera en este viaje",
    "Required only for empty shipments. Specifies the trip destination.": "Requerido únicamente para embarques vacíos. Especifica el destino del viaje.",
    "Shipments": "Embarques",
    "Shipments will be removed": "Los embarques seleccionados serán eliminados",
    "Yes, Delete shipments": "Si, Eliminar embarques",
    "Are you sure to do this?": "Está seguro?",
    "Error deleting shipments": "Hubo un error al tratar de eliminar los embarques seleccionados",
    "Please select shipments to delete": "Selecciona los embarques que deseas eliminar.",
    "Deletions selected shipments": "Se han eliminado los embarques seleccionados",
    "New Commodity": "Agregar Mercancía",
    "Required fields commodity": "Porfavor ingrese campos obligatorios antes de agregar mercancía",
    "Type": "Tipo",
    "Choose Type": "Ingrese Type",
    "Entry": "Número de Entrada",
    "Enter Port of Lading name": "Ingrese Nombre de Puerto de Embarque",
    "Enter Port of Lading": "Ingrese Puerto de Embarque",
    "Enter SCN": "Número de Control de Embarque",
    "One is required": "Al menos uno es obligatorio",
    "Conveyance must have insurance info": "El Vehículo debe tener datos de Aseguradora",
    "Hazmat": "Hazmat",
    "Bulk Actions": "Acciones Masivas",
    "Delete commodities": "Eliminar Mercancías",
    "Add Commodity": "Agregar Mercancía",
    "Enter Shipper": "Ingrese Exportador",
    "Enter Consignee": "Ingrese Consignatario",
    'Trip updated successfully.': "Viaje actualizado con éxito",
    'There was an error trying to update the trip.': "Hubo un error al intentar actualizar el viaje",
    "This report does not include shipments type 321": "Este reporte no incluye embarques tipo 321",
    "Enter Secondary Carrier": "Ingrese Transportista Secundario",
    "Secondary Carrier": "Transportista Secundario",
    "Sublocation Port": "Puerto de Sublocalización",
    "Destination Port": "Puerto de Destino",
    "Enter Destination port name": "Ingrese nombre de puerto de destino",
    "Enter Sublocation port name": "Ingrese nombre de puerto de sublocalización",
    "First select a destination port": "Primero seleccione un puerto de destino",
    "Outbound State": "Estado de Salida",
    "Enter state name": "Ingrese nombre de estado",
    "Enter Outbound state name": "Ingrese nombre de estado de salida",
    "Outbound Port": "Puerto de Salida",
    "First select outbound state": "Primero seleccione estado de salida",
    "Firms Code": "Código de Firmas",
    "Enter Firms Code": "Ingrese Código de Firmas",
    "First select a US Port of Destination": "Primero seleccione un Puerto de Destino",
    "Consolidated Freight": "Código de Flete Consolidado",
    //Commoditites
    "Description": "Descripción",
    "New Shipment": "Agregar Embarque",
    "Port of Lading": "Puerto de Embarque",
    //Summary
    "Back to dashboard": "Regresar a Inicio",
    "Notes": "Notas",
    "Documents": "Documentos",
    "Options": "Opciones",
    "Receipt": "Recibo",
    "Coversheet": "Portada",
    "Enlarged QR": "QR Ampliado",
    "Manifest": "Manifiesto",
    "7533": "7533",
    "7533Entry": "7533 (Entrada)",
    "7523": "7523",
    "Send Trip": "Enviar Viaje",
    "Summary": "Resumen del Viaje",
    "Arrival Details": "Detalles de Arribo",
    "There are no conveyances to show": "No hay vehículos que mostrar",
    "There are no equipments to show": "No hay equipos que mostrar",
    "There are no drivers to show": "No hay choferes que mostrar",
    "successfully deleted from this organization.": "correctamente eliminado de la organización.",
    "successfully sent for deletion.": "correctamente enviado para eliminar.",
    "Do you want to delete this trip?": "Desea eliminar este viaje?",
    "No, cancel": "No, cancelar",
    "Yes, delete trip": "Si, eliminar este viaje",
    "will be permanently deleted from your organization.": "será eliminado permanentemente de su organización",
    "Shipments saved correctly.": "Embarque guardado correctamete",
    "There was an error trying to upload shipments.": "Hubo un error intentando cargar los embarques",
    "WARNING": "ATENCIÓN:",
    "Some shipments are rejected:": "Algunos embarques fueron rechazados",
    "and": "y",
    "more": "más",
    "You can add all shipments you need on this trip.": "Añada todos los embarques que necesite en su viaje",
    "Trip copied successfully.": "Viaje copiado con éxito",
    "There was an error trying to copy the trip.": "Hubo un error intentando copiar el viaje",
    'Copy Trip Details': "Copiar detalles de viaje",
    "Carrier is a required field": "Transportista es un campo obligatorio",
    "Arrival Port is a required field": "Puerto de arribo obligatorio",
    "Trip number already taken, try another one.": "Número de viaje existente, intente otro",
    "Trip Number is a required field": "Número de viaje obligatorio",
    "Trip Number must be at least 3 characters": "Número de viaje debe contener al menos 3 caracteres",
    "Conveyance is a required field": "Vehículo obligatorio",
    "At least one Driver must be specified": "Se debe especificar al menos un chofer",
    "Type is a required field": "Tipo obligatorio",
    "SCN is a required field": "Número de control obligatorio",
    "SCN must be at least 3 characters": "SCN debe contener al menos 3 caracteres",
    "Shipper is a required field": "Exportador obligatorio",
    "Consignee is a required field": "Consignatario obligatorio",
    "Port of Lading is a required field": "Puerto de embarque obligatorio",
    "Entry # must be at least 3 characters": "Número de puerto debe contener al menos 3 caracteres",
    "No matches found": "Sin coincidencias",
    "Search Shipment": "Buscar Embarque",
    "Find SCN": "Buscar SCN",
    "Filter by Status": "Filtrar por Estatus",
    "There are no passengers to show": "No hay pasajeros que mostrar",
    "SCN to search": "SCN a buscar",
    "Passenger(s)": "Pasajero(s)",
    //Notifications
    "Events": "Eventos",
    "Shipment": "Embarque",
    "No messages yet": "No hay mensajes aún",
    "Available Notifications": "Una vez enviado el viaje a CBP, todas las notificaciones se mostrarán aquí.",
    "Add Notifications Emails": "Agregue los correos para recibir notificaciones de los viajes que cree.",
    "Enter email separated by commas": "Ingrese correos separados por comas",
    "Update Emails": "Actualizar Correos",
    "Trip Events": "Eventos del Viaje",
    "Trip Accepted by CBP": "Viaje Aceptado por CBP",
    "Trip Arrived by CBP": "Viaje Arribado por CBP",
    "Trip Released by CBP": "Viaje Liberado por CBP",
    "Trip Deleted by CBP": "Viaje Eliminado por CBP",
    "Trip Rejected by CBP": "Viaje Rechazado por CBP",
    "Shipment Events": "Eventos del Embarque",
    "Entry on file": "Enlazado",
    "Entry On File": "Enlazado",
    "QP on file": "QP Registrado",
    "Entry not on file": "No Enlazado",
    "Entry Not On File": "No Enlazado",
    "Entry port code mismatch": "Discrepancia en Entry de código de puerto",
    "Overage": "Excedente",
    "Shortage": "Faltante",
    "Notification Emails": "Notificaciones por correo",
    "Arrival Date": "Fecha de Arribo",
    "UOM": "Unidad de Medida",
    "Gross Weight UOM": "Unidad de Peso",
    "Edit Shipment": "Editar Embarque",
    "Origin": "Origen",
    "Status": "Estatus",
    "On File": "Enlazado",
    "Send as": "Enviar como",
    "H Tariff": "Tarifa H",
    "Truck": "Terrestre",
    "No notifications to show": "No hay notificaciones para mostrar",
    "Select a notification to view the full message.": "Seleccione una notificación para ver el mensaje completo.",
    "Created": "Creado",
    //Tenant
    "The role was updated successfully!": "El rol fue actualizado correctamente!",
    "New Tenant": "Agregar Distribuidor",
    "Tenant": "Distribuidor",
    "Tenant Name": "Nombre de Distribuidor",
    "Allowed Domains": "Dominios permitidos",
    "Tenant Address": "Dirección de Distribuidor",
    "Street Address": "Dirección",
    "Tenant Settings": "Configuración de Distribuidor",
    "Primary Color": "Color Primario",
    "Secondary Color": "Color Secundario",
    "Logo": "Logotipo",
    "Upload a file": "Cargar archivo",
    "Tenants": "Distribuidores",
    "Invite Members": "Invitar Miembros",
    "Invite Member": "Invitar Miembro",
    "Invite Members Collaborate": "Invitar nuevos miembros a su Organización",
    "Enter email separated by commas": "Ingrese los correos electrónicos separados por comas",
    "Enter some emails": "Ingrese correos electrónicos",
    "Invite member now": "Invitar a miembro",
    "Invite": "Invitar",
    "Members": "Miembros",
    "Invited to join": "Invitar a unirse",
    "Resend invite": "Reenviar Invitación",
    "Tenant Name is a required field": "Nombre de distribuidor obligatorio",
    "url is a required field": "url obligatorio",
    "Street Address is a required field": "Dirección obligatoria",
    "Address #1 is a required field": "Dirección #1 obligatorio",
    "City is a required field": "Ciudad obligatoria",
    "State is a required field": "Estado obligatorio",
    "Zip Code is a required field": "Código postal obligatorio",
    "Postal Code is a required field": "Código postal obligatorio",
    "Country is a required field": "País obligatorio",
    "Invalid phone number": "Número de teléfono inválido",
    "Contact Email must be a valid email": "Correo electrónico debe ser un correo válido",
    //Organization
    "Organization Name": "Nombre de Organización",
    "Save Changes": "Guardar Cambios",
    "Primary Contact Info": "Información Principal de Contacto",
    "Owner contact information": "Información de Contacto de Dueño",
    "Organization Address": "Dirección de Organización",
    "FTP Settings": "Configuración FTP",
    "Optima 3 identifier": "Indentificador Optima 3",
    "FTP Code": "Código FTP",
    "Auto Send": "Envío Automático",
    "Carrier Settings": "Configuración de Transportista",
    "Search Carrier": "Buscar Transportista",
    "Enter Carrier Name": "Ingrese Nombre del Transportista",
    "My Carriers": "Mis Transportistas",
    "Organization updated successfully": "La Organización se actualizó correctamente",
    "Error Updating Organizations": "Hubo un error al intentar actualizar la configuración de la Organización",
    "New Organization": "Agregar Organización",
    "saved successfully": "se guardo correctamente",
    "There was an error adding a Organization.": "Hubo un problema al intentarg guardar la Organización",
    "The invites have been sent successfully.": "Las invitaciones se enviaron correctamente",
    "Organizations": "Organizaciones",
    "Status Settings": "Configuración de Estatus de Cuentas",
    "Selected Organizations": "Organizaciones Seleccionadas",
    "ACTIVATE": "ACTIVAR",
    "DEACTIVATE": "DESACTIVAR",
    "ORGANIZATIONS": "ORGANIZACIONES",
    "Clear": "Limpiar",
    "Apply Change": "Aplicar Cambio",
    "Search User": "Buscar Usuario",
    "Enter User": "Ingrese Usuario",
    "Selected Users": "Usuarios Seleccionados",
    "USERS": "USUARIOS",
    "Send Instructions": "Enviar Instrucciones",
    "Sign in": "Iniciar sesión",
    "Back to Sign in": "Regresar a inicio",
    "Don´t have an account?": "No tiene cuenta?",
    "Create one": "Crear una",
    "We´ll help you reset": "Te ayudaremos a restablecerlo y volver a la normalidad. Ingrese su correo electrónico para restablecer su contraseña.",
    "Password": "Contraseña",
    "More than 8 characters": "Más de 8 caractéres",
    "Join to": "Unirse a",
    "Loading": "Cargando",
    "By signing up, I accept the": "Al Registrarse, Acepto",
    "Terms of Use": "Términos de Uso",
    "and": "y",
    "Privacy Policy": "Políticas de Privacidad",
    "Sign up and Join": "Registrarse y Unirse",
    "Sign Up": "Registrarme",
    "Verify email": "Verificar correo electrónico",
    "Resend code": "Reenviar Código",
    "Make sure to keep this window open": "Asegurese de tener esta ventana abierta mientras revisa su correo",
    "Please check your email inbox": "Por favor, revise su bandeja de entrada. Recibirá un Código de Verificación pronto!",
    "We just sent a six-digit code": "Le enviamos un código de seis dígitos a su correo electrónico. Ingrese el siguiente código para confirmar su correo.",
    "The Page you are looking for doesn´t exist": "La página que estás buscando no existe o ha ocurrido un error. Regrese a la página principal",
    "The user has been removed successfully.": "El usuario fue eliminado de forma exitosa.",
    "The invite has been removed successfully.": "La invitación fue eliminada con éxito",
    "The invites have been sent successfully.": "Las invitaciones fueron enviadas de forma exitosa",
    "Page not found": "Página no encontrada",
    "Return to Home": "Regresar a Inicio",
    "User": "Usuario",
    "Number": "Numero",
    "Nationality": "Nacionalidad",
    "Weight": "Peso",
    "Received": "Recibido",
    "Tools": "Herramientas",
    "Channels": "Canales",
    "Trip Control": "Control de Viaje",
    "Unassigned Tenants": "Distribuidores sin asignar",
    "Support": "Soporte",
    "Search Tenants": "Buscar Distribuidores",
    "Search tenants": "Buscar Distribuidores",
    "Search Tenant": "Buscar Distribuidor",
    "Organization ID": "ID de Organización",
    "Selected tenants": "Distribuidores seleccionados",
    "Tenant users": "Usuarios del distribuidor",
    "Please select a user": "Seleccione un usuario",
    "Selected Language": "Idioma seleccionado",
    "Email Notifications": "Notificaciones por correo",
    "EMAIL": "Correo",
    "ACTIVE": "ACTIVO",
    "INACTIVE": "INACTIVO",
    "Expired": "Expirado",
    "Message": "Mensaje",
    "Active since": "Activo desde",
    "Expires on": "Expira el",
    "Generate new key": "Generar nueva clave",
    "Generate key": "Generar clave",
    "Save Key": "Guardar clave",
    "Headers Webhook": "Encabezados Webhook",
    "Trip ID": "ID Viaje",
    "EDI Type": "Tipo EDI",
    "EDI Status": "Estatus EDI",
    "Error Message": "Mensaje de error",
    "Default Information": "Información Default",
    "To US": "A EE.UU",
    "To CA": "A CA",
    "Enter Country": "Ingrese País",
    "Commodity UOM": "Unidad de Medida de Mercancía",
    "Consignee State": "Estado del Consignatario",
    "Select UOM": "Seleccione Unidad de Medida",
    "Enter Arrival Port": "Ingrese Puerto de Arribo",
    "You can not have both MX to US and CA to US active at the same time": "No puede tener ambos MX a US y CA a US activos al mismo tiempo",
    "Documents in email": "Documentos en correo",
    //Logs
    "Search Log Type": "Buscar tipo de log",
    "Organization Logs": "Logs de Organización",
    "User Logs": "Logs de Usuario",
    "User Invite Logs": "Logs de Invitación de Usuario",
    "Trip Logs": "Logs de Viaje",
    "Shipment Logs": "Logs de Embarque",
    "Party Logs": "Logs de Empresas",
    "Carrier Logs": "Logs de Transportistas",
    "Conveyance Logs": "Logs de Vehículos",
    "Equipment Logs": "Logs de Equipos",
    "Driver Logs": "Logs de Choferes",
    "Passenger Logs": "Logs de Pasajeros",
    "Search Field": "Buscar por campo",
    "Action": "Acción",
    "Entity": "Entidad",
    "Date": "Fecha",
    "Success": "Éxito",
    //Notifications
    "Search Notification": "Buscar Notificación",
    "Title": "Título",
    "Portal": "Portal",
    "Informative": "Informativa",
    "Default Message": "Mensaje Default",
    "Search default message": "Buscar mensaje default",
    "English Message": "Mensaje en inglés",
    "Spanish Message": "Mensaje en español",
    "Link title": "Título link",
    "Link": "Link",
    "Expiration Date": "Fecha de Expiración",
    "Optima Notifications": "Notificaciones Optima",
    //Reports
    "General Report": "Reporte General",
    "Monthly Report": "Reporte Mensual",
    "Error loading trip report. Please try a shorter date range.": "Error al cargar el reporte de viajes. Intente con un rango de fechas más corto.",
    //Conveyance
    "Enter Type": "Ingrese Tipo",
    "Primary Plate State": "Estado de Placa Principal",
    "Secondary Plate Country": "País de Placa Secundaria",
    "Secondary Plate State": "Estado de Placa Secundaria",
    "Seals": "Sellos",
    "IIT": "IIT",
    "Has IIT?": "Tiene IIT?",
    "Has IIT": "Tiene IIT",
    "IIT Type": "Tipo IIT",
    "Seals and IIT Info": "Sellos e Información IIT",
    "Edit": "Editar",
    "Copy": "Copiar",
    "Edit Trip Details": "Editar Detalles de Viaje",
    "Save Changes": "Guardar Cambios",
    "Change": "Cambiar",
    "Trip notes saved successfully.": "Las notas del Viaje se guardaron correctamente",
    "There was an error saving this Trip notes.": "Hubo un error al intentar guardar las notas del Viaje",
    "Notes relevant to this trip": "Notas relevantes de este Viaje",
    "Up to 160 characters": "Más de 160 caracteres",
    "Add Seals": "Agregar Sellos y IIT",
    "View": "Ver",
    "Remove": "Eliminar",
    "Edit Seals": "Editar Sellos",
    "New Conveyance": "Agregar Vehículo",
    "Save Conveyance": "Guardar Vehículo",
    "New Equipment": "Agregar Equipo",
    "Last Update": "Última Actualización",
    "Add IIT": "Agregar IIT",
    "Yes, Send as ADD the selected shipments": "Si, Marcar embarques como NUEVO",
    "Shipments will be marked as ADD": "Los embarques se marcaran como NUEVO",
    "Yes, Send as CHANGE the selected shipments": "Si, Marcar embarques como CAMBIO",
    "Shipments will be marked as CHANGE": "Los embarques se marcaran como CAMBIO",
    "Yes, Send as DELETE the selected shipments": "Si, Marcar embarques como ELIMINACIÓN",
    "Shipments will be marked as DELETE": "Los embarques se marcaran como ELIMINACIÓN",
    "Yes, Clear Send as the selected shipments": "Si, limpiar campo Enviar como de embarques",
    "Send as will be clear": "Se limpiara el campo Enviar como",
    "Delete Shipments": "Eliminar Embarques",
    "Save Shipment": "Guardar Embarque",
    "In Charge": "A cargo",
    "Send as ADD": "Marcar como NUEVO",
    "Send as CHANGE": "Marcar como CAMBIO",
    "Send as DELETE": "Marcar como ELIMINACIÓN",
    "Clear Send as": "Limpiar campo enviar como",
    "Send As": "Enviar como",
    "Choose Option": "Seleccionar",
    "All Shipments": "Todos los Embarques",
    "Please resend Trip": "Este Viaje contiene información que aún no se ha enviado a Aduana y es posible que tenga problemas con su recibo al cruzar. Por favor reenvie el viaje.",
    "Basic Information": "Información Básica",
    "FTP": "FTP",
    "Contacts": "Contactos",
    "Mobile": "Celular",
    "Position": "Cargo",
    "Add Contact": "Agregar Contacto",
    "Contact Information": "Información de Contacto",
    "Contact Name": "Nombre de Contacto",
    "Contact Information to Show": "Información de Contacto a Mostrar",
    "contactName is a required field": "Nombre de Contacto es obligatorio",
    "Need Help?": "Necesitas Ayuda?",
    "User Information": "Información de Usuario",
    "Auto Send": "Auto envío",
    "Current Month Trips": "Viajes del mes en curso",
    "Last Month Trips": "Viajes del mes pasado",
    "In Bond Trips": "Viajes In Bond",
    "Section 321 Trips": "Viajes Sección 321",
    "Current Year Trips": "Viajes del año en curso",
    "Last Year Trips": "Viajes del año pasado",
    "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind. The Ticket Number is [---].": "CBP está presentando problemas con su sistema a nivel nacional. Es el tercer incidente de este tipo en el día. # de incidente [---].",
    "CBP is experiencing problems with their acceptance messages nationwide. This is the third incident today of this kind.  Ticket not issued yet.": "CBP está presentando problemas con su sistema a nivel nacional. Es el tercer incidente de este tipo en el día. El # de incidente no ha sido publicado aun.",
    "CBP is experiencing problems with intermittent interruptions with output messages being generated and sent out. The Ticket Number is [---]. Expect a delay of 15-25 minutes to get some Accepted messages.": "CBP está presentando interrupciones intermitentes con su sistema de respuestas al ser generados y enviados. Numero de incidente [---]. Las respuestas estan tomando de 15-25 minutos debido al mismo incidente.",
    "A few minutes ago, CBP experienced an interruption with output messages. ACE system has already been reestablished. Ticket number is [---].": "Hace un par de minutos, CBP presentó una interrupción con los mensajes de salida. El sistema ACE, ha sido restablecido. El número de incidente es  [---].",
    "CBP is currently experiencing a delay to process and submit their messages. Due to maintenance in their system TICKET .": "CBP está presentando una demora para procesar y enviar mensajes a los manifiestos. Debido a una actualizacion en su sistema. TICKET .",
    "SCN already taken.": "SCN ya fue utilizado.",
    "Verify your email address": "Verifica tu Correo Electrónico",
    "Start creating your first trip": "Empieza creando tu primer viaje",
    "Any new trip you create will be displayed here.": "Cualquier viaje nuevo se mostrará aquí",
    "Please complete the trip, Driver and Conveyance are required": "Porfavor complete el viaje, Conductor y Vehículo son obligatorios",
    "My SCACs": "Mis SCACs",
    "Conveyance Only": "Vehículo vacío",
    "Empty Equipment": "Equipo vacío",
    "Regular": "Regular",
    //Calendar
    'Time': 'hora',
    'Estimated arrival time, should be at least one hour from now': 'Hora de arribo estimada, debe ser al menos una hora a partir de esta momento',
    "Delete Trip": "Eliminar viaje",
    "Empty": "Vacío",
    "Bond Info": "Info Bond",
    //STATUS
    "Inactive": "Borrador",
    "EDI File Ready to Send": "Archivo EDI Listo para Enviar",
    "EDI File Ready to Send For Deletion": "Archivo EDI Listo para Enviar a Eliminación",
    "EDI File Ready to Send For Edition": "Archivo EDI Listo para Enviar a Edición",
    "Sent to CBP": "Enviado a CBP",
    "Sent For Deletion to CBP": "Enviado para Eliminación a CBP",
    "Sent For Edition to CBP": "Enviado para Edición a CBP",
    "Received by CBP": "Recibido por CBP",
    "Syntax Rejected": "Sintaxis Rechazada",
    "Accepted by CBP": "Aceptado por CBP",
    "Rejected by CBP": "Rechazado por CBP",
    "Deletion Accepted by CBP": "Eliminación Aceptada por CBP",
    "Deletion Rejected by CBP": "Eliminación Rechazada por CBP",
    "Edition Accepted by CBP": "Edición Aceptada por CBP",
    "Edition Rejected by CBP": "Edición Rechazada por CBP",
    "Arrived": "Arribado",
    "Released": "Liberado",
    "Entry On File": "Entrada en Archivo",
    "Entry Not On File": "Entrada en Archivo",
    "Deletion Accepted": "Eliminación Aceptada",
    "Deletion Rejected": "Eliminación Rechazada",
    "Edition Accepted": "Edición Aceptada",
    "Edition Rejected": "Edición Rechazada",
    //Send As Options
    "Original": "Original",
    "Preliminary": "Preliminar",
    "In-transit": "En tránsito",
    "Amendment": "Modificación",
    //350 EVENTS
    "Trip arrived by CBP": "Viaje arribado",
    "Cancel Truck Arrival": "Cancelar arribo de camión",
    "Carrier does not possess valid U.S operating authority": "El transportista no posee autoridad de operación válida en los EE. UU.",
    "Carrier has an Out of Service order against it": "El transportista tiene una orden de fuera de servicio en su contra",
    "Safety score indicates inspection is warranted": "La puntuación de seguridad indica que se justifica una inspección",
    "Carrier check not preformed, data not available at this time": "La verificación del transportista no se realizó, los datos no están disponibles en este momento",
    "Carrier's current insurance does not meet the minimum level or better": "El seguro actual del transportista no cumple con el nivel mínimo o mejor",
    "Carrier data not found in FMCSA systems": "Datos del transportista no encontrados en los sistemas de FMCSA",
    "Driver check not preformed, data not available at this time": "La verificación del conductor no se realizó, los datos no están disponibles en este momento",
    "Driver does not have proper CDL endorsements for HAZMAT cargo": "El conductor no tiene endosos CDL adecuados para carga HAZMAT",
    "Driver does not have valid/current CDL or equivalent (MX or CA)": "El conductor no tiene un CDL válido/vigente o equivalente (MX o CA)",
    "Trailer check not preformed, data not available at this time": "La verificación del remolque no se realizó, los datos no están disponibles en este momento",
    "No current CVSA decal on file. Please check visually": "No hay calcomanía CVSA actual en el archivo. Por favor, revise visualmente",
    "Tractor check not preformed, data not available at this time": "La verificación del tractor no se realizó, los datos no están disponibles en este momento",
    "Crew/passengers Held": "Tripulación/Pasajeros retenidos",
    "Equipment Held": "Equipo retenido",
    "Hold Conveyance": "Retener vehículo",
    "Trip Held": "Viaje retenido",
    "Overdue Conveyance Arrival": "Llegada de vehículo vencida",
    "Conveyance Released": "Vehículo liberado",
    "Crew/Passengers Released": "Tripulación/pasajeros liberados",
    "Equipment Released": "Equipo liberado",
    "Trip released by CBP": "Viaje liberado",
    "Driver account information needs to be updated with country of driver's citizenship.": "La información de la cuenta del conductor necesita ser actualizada con el país de ciudadanía del conductor.",
    "Driver account information needs to be updated with an approved WHTI document.": "La información de la cuenta del conductor necesita ser actualizada con un documento WHTI aprobado.",
    "Conveyance added by Customs": "Vehículo agregado por Aduanas",
    "Conveyance updated by Customs": "Vehículo actualizado por Aduanas",
    "Conveyance removed by Customs": "Vehículo eliminado por Aduanas",
    "Equipment added by Customs": "Equipo agregado por Aduanas",
    "Equipment updated by Customs": "Equipo actualizado por Aduanas",
    "Equipment removed by Customs": "Equipo eliminado por Aduanas",
    "Crew added by Customs": "Tripulación agregada por Aduanas",
    "Crew updated by Customs": "Tripulación actualizada por Aduanas",
    "Crew removed by Customs": "Tripulación eliminada por Aduanas",
    //
    "Search Trip Notification": "Buscar Notificación de Viaje",
    "Selected Notifications": "Notificaciones Seleccionadas",
    "Search Shipment Notification": "Buscar Notificación de Embarque",
    "API Name": "Nombre de API",
    "Client Secret": "Clave Secreta",
    "Generate key": "Generar Clave",
    "Update Key": "Actualizar Clave",
    //Shipmente Notifications
    "Duplicate in-bond request via QP, carrier's in-bond accepted": "Solicitud de in-bond duplicada a través de QP, in-bond aceptado del transportista",
    "Arrival of in-bond-complete movement": "Llegada del movimiento completo de in-bond",
    "Arrival of in-bond-bill of lading": "Llegada de la carta de porte de in-bond",
    "Arrival of in-bond-container": "Llegada del contenedor de in-bond",
    "Master in-bond advisory": "Asesoramiento maestro de in-bond",
    "Entered: Intensive examination required": "Entrado: Examen intensivo requerido",
    "Released: Intensive examination completed": "Liberado: Examen intensivo completado",
    "Entered and released: general examination": "Entrado y liberado: examen general",
    "Customs hold removed at port of in-bond destination": "Retención de aduanas eliminada en el puerto de destino de in-bond",
    "Customs hold placed at port of in-bond destination": "Retención de aduanas colocada en el puerto de destino de in-bond",
    "Customs hold placed at port of discharge": "Retención de aduanas colocada en el puerto de descarga",
    "Customs hold removed at port of discharge": "Retención de aduanas eliminada en el puerto de descarga",
    "In-bond Movement Authorized: bill of Lading open": "Movimiento de in-bond autorizado: carta de porte abierta",
    "Bill of lading late in 5 days": "Carta de porte tarde en 5 días",
    "Bill of lading late": "Carta de porte tarde",
    "Pending elegible general order": "Orden general elegible pendiente",
    "Ordered to general order": "Ordenado al orden general",
    "Seized": "Incautado",
    "Sent to general order": "Enviado al orden general",
    "USDA Miscellaneous hold removed at port of in-bond destination": "Retención miscelánea del USDA eliminada en el puerto de destino de in-bond",
    "USDA miscellaneous hold placed at port of in-bond destination": "Retención miscelánea del USDA colocada en el puerto de destino de in-bond",
    "USDA miscellaneous hold placed at port of discharge": "Retención miscelánea del USDA colocada en el puerto de descarga",
    "USDA miscellaneous hold removed at oprt of discharge": "Retención miscelánea del USDA eliminada en el puerto de descarga",
    "Other government agency hold removed at port of in-bond destination": "Retención de otras agencias gubernamentales eliminada en el puerto de destino de in-bond",
    "Other government agency hold placed at port of in-bond destination": "Retención de otras agencias gubernamentales colocada en el puerto de destino de in-bond",
    "Other government agency hold placed at port of discharge": "Retención de otras agencias gubernamentales colocada en el puerto de descarga",
    "Other government agency hold removed at port of discharge ": "Retención de otras agencias gubernamentales eliminada en el puerto de descarga",
    "Override": "Anulación",
    "Entry cancelled": "Entrada cancelada",
    "Export of in-bond-complete movement": "Exportación del movimiento completo de in-bond",
    "Export of in-bond-bill of lading": "Exportación de la carta de porte de in-bond",
    "Export of in-bond-container": "Exportación del contenedor de in-bond",
    "Overdue export": "Exportación vencida",
    "Change arrival of in-bond-complete movement": "Cambio de llegada del movimiento completo de in-bond",
    "Change arrival of in-bond-bill of lading": "Cambio de llegada de la carta de porte de in-bond",
    "Change arrival of in-bond-container": "Cambio de llegada del contenedor de in-bond",
    "Entry processing hold": "Retención de procesamiento de entrada",
    "Entry processing hold removed": "Retención de procesamiento de entrada eliminada",
    "Change export of in-bond-complete movement": "Cambio de exportación del movimiento completo de in-bond",
    "Change export of in-bond-bill of lading": "Cambio de exportación de la carta de porte de in-bond",
    "Change of export of in-bond-container": "Cambio de exportación del contenedor de in-bond",
    "Delete arrival of in-bond by complete movement": "Eliminar llegada de in-bond por movimiento completo",
    "Delete arrival of in-bond-bill of lading": "Eliminar llegada de la carta de porte de in-bond",
    "Delete arrival of in-bond-container": "Eliminar llegada del contenedor de in-bond",
    "Delete export of in-bond-complete": "Eliminar exportación de in-bond completa",
    "Delete export of in-bond-bill of lading": "Eliminar exportación de la carta de porte de in-bond",
    "Delete export of in-bond-container": "Eliminar exportación del contenedor de in-bond",
    "Bill on file": "Factura en archivo",
    "Intensive hold for USDA placed at port of discharge": "Retención intensiva para USDA colocada en el puerto de descarga",
    "Inspection/document review fir USDA placed at the port of discharge": "Inspección/revisión de documentos para USDA colocada en el puerto de descarga",
    "Fumigation hold for USDA placed at the port of discharge": "Retención de fumigación para USDA colocada en el puerto de descarga",
    "Intensive hold for USDA removed at port of discharge": "Retención intensiva para USDA eliminada en el puerto de descarga",
    "Inspection/document review for USDA removed at the port of discharge": "Inspección/revisión de documentos para USDA eliminada en el puerto de descarga",
    "Fumigation hold for USDA removed at the port of discharge": "Retención de fumigación para USDA eliminada en el puerto de descarga",
    "Intensive hold for USDA placed at port of in-bond destination": "Retención intensiva para USDA colocada en el puerto de destino de in-bond",
    "Inspection/document review for USDA placed at the port of in-bond destination": "Inspección/revisión de documentos para USDA colocada en el puerto de destino de in-bond",
    "Fumigation hold for USDA placed at the port of in-bond destination": "Retención de fumigación para USDA colocada en el puerto de destino de in-bond",
    "Intensive hold for USDA removed at port of in-bond destination": "Retención intensiva para USDA eliminada en el puerto de destino de in-bond",
    "Inspection/document review for USDA removed at the port of in-bond destination": "Inspección/revisión de documentos para USDA eliminada en el puerto de destino de in-bond",
    "Fumigation hold for USDA removed at the port of in-bond destination": "Retención de fumigación para USDA eliminada en el puerto de destino de in-bond",
    "PN on file": "PN en archivo",
    "PN not on file": "PN no en archivo",
    "Entry port code mismatch": "Código de puerto de entrada no coincide",
    "Seals have saved successfully.": "Sellos actualizados correctamente.",
    "Each seal allows 2 to 15 alphanumeric characters. Maximum 4 seals": "Cada sello permite de 2 a 15 caracteres alfanuméricos. Máximo 4 sellos.",
    "Each seal allows 2 to 15 alphanumeric characters.": "Cada sello permite de 2 a 15 caracteres alfanuméricos.",
    //Default Config
    "Shipment Country of Origin": "País de Origen del Envío",
    "Shipper State": "Estado Exportador",
    "Quantity UOM": "Quantity UOM",
    "Consignee Province": "Estado Consignatario",
    "Arrival State": "Estado de Arribo",
    "Arrival Port": "Puerto de Arribo",
    "Shipment Type": "Tipo de Embarque",
    "Arrival State": "Estado de Arribo",
    "Arrival Port": "Puerto de Arribo",
    "Shipment Type": "Tipo de Embarque",
    "Plate Country": "País Placa",
    "Plate State": "Estado Placa",
    "License Country": "País Licencia",
    "License State": "Estado Licencia",
    "Saved succesfully": "Guardado exitosamente",
    "Please try again": "Por favor intente de nuevo",

    "Required": "Obligatorio",
    "Carrier Selection Required": "Seleccione un Carrier",
    "Select a carrier from 'Select Carrier' on the left to view the catalog.": "Seleccione un carrier en 'Select Carrier' a la izquierda para ver el catálogo.",
    "No matches found": "No hay coincidencias",
    "No shipments found with this information.": "No se encontraron embarques con esta información.",
    "When applying changes, your user session will be reset.": "Al aplicar cambios, tu sesión de usuario se restablecerá.",
    "AcceptedShipments": "ACEPTADOS",
    "SentShipments": "ENVIADOS",
    "RejectedShipments": "RECHAZADOS",
    "DeletedShipments": "ELIMINADOS",
    "DraftShipments": "BORRADORES",
    "Hazmat columns": "Las columnas de materiales peligrosos (Clase HM y Código HM UN) ahora están visibles. Desplázate hacia la derecha para verlas.",
    "Trip Address": "Dirección de Viaje",
    "Destination": "Dirección de Viaje",
    "Delete All Shipments Alert": "Esto eliminará TODOS los {{count}} embarque(s). Esta acción no se puede deshacer.",
    "Delete All Shipments": "Eliminar todos los Embarques",
    "Delete Selected ({{count}})": "Eliminar Seleccionados ({{count}})",
    "Delete All ({{count}})": "Eliminar Todos ({{count}})",
    "Delete Selected Shipments": "Eliminar Embarques Seleccionados",
    "Delete Selected Shipments Alert": "Esto eliminará {{count}} embarque(s). Esta acción no se puede deshacer.",

    "Record Identifier B01/Segment M11 data was not transmitted": "No se transmitieron los datos del Identificador de Registro B01/Segmento M11",
    "Invalid party identification": "Identificación de parte inválida",
    "Code missing or Invalid.": "Código faltante o inválido",
    "A shipment control number has more than 12 characters.": "El número de control de envío tiene más de 12 caracteres",
    "weight is ‘0’": "El peso es ‘0’",
    "UOM is code not on list.": "La unidad de medida no está en la lista de códigos",
    "The inbond number specified does not exist or is invalid.": "El número de in-bond especificado no existe o es inválido",
    "port of arrival specified does not exist or is invalid.": "El puerto de llegada especificado no existe o es inválido",
    "Port of loading code doesn’t exist": "El código de puerto de carga no existe",
    "Shipment control number reused within specified period when an active bill exists.": "Número de control de envío reutilizado dentro del período especificado cuando existe un conocimiento activo",
    "Amendment code does not exist for shipment use.": "El código de enmienda no existe para uso en envíos",
    "Shipment commodity missing.": "Falta la mercancía del envío",
    "Date is missing or invalid": "Fecha faltante o inválida",
    "": "",
    "TE/IE shipment and commodity code specified does not exist.": "El envío TE/IE y el código de mercancía especificado no existen",
    "Indicates the manifest transmission was successful": "Indica que la transmisión del manifiesto fue exitosa",
    "A district/port site record exists but the user is not authorized to transmit": "Existe un registro de distrito/puerto pero el usuario no está autorizado para transmitir",
    "Arrival by container/equipment rejected. User attempts to arrive inbond by container/equipment but 1 or more inbonds or bills associated with the container are already arrived. User must either unarrive the inbonds or bills and then arrive the container/equipment, or arrive all the inbonds or bills individually.": "Llegada por contenedor/equipo rechazada. El usuario intenta registrar llegada de in-bond por contenedor/equipo pero 1 o más in-bonds o conocimientos asociados con el contenedor ya llegaron. El usuario debe cancelar la llegada de los in-bonds o conocimientos y luego registrar la llegada del contenedor/equipo, o registrar la llegada de todos los in-bonds o conocimientos individualmente",
    "FIRMS code of second notify party doesn’t exist": "El código FIRMS de la segunda parte notificante no existe",
    "Manifest Unit Code is other than codes in note for this element": "El código de unidad de manifesto es diferente a los códigos en la nota para este elemento",
    "Shipment control number specified doesn’t exist": "El número de control de envío especificado no existe",
    "Time is missing or invalid": "Hora faltante o inválida",
    "C4 code specified for BRASS shipment does not exist or is invalid": "El código C4 especificado para envío BRASS no existe o es inválido",
    "M1201 is type ‘63’ CBP port of in-bond destination is a Mexican border port and the pedimento number is missing or invalid.": "M1201 es tipo ‘63’, el puerto CBP de destino in-bond es un puerto fronterizo mexicano y el número de pedimento falta o es inválido",
    "ACE ID specified does not exist or is invalid per carrier account": "El ACE ID especificado no existe o es inválido según la cuenta del transportista",
    "State/province doesn’t exist": "El estado/provincia no existe",
    "Country is other than US,MX,CA and is missing": "El país es diferente a US, MX, CA y falta",
    "Countryspecified doesn’t exist or is invalid": "El país especificado no existe o es inválido",
    "Conveyance ID specified doesn’t exist or is invalid per carrier account": "El ID del medio de transporte especificado no existe o es inválido según la cuenta del transportista",
    "Insurance information not complete for trip.": "Información de seguro incompleta para el viaje",
    "Insurance information not maintained for trip.": "Información de seguro no mantenida para el viaje",
    "No crewmember is listed as ‘EJ’.": "Ningún miembro de la tripulación está listado como ‘EJ’",
    "No crewmember is listed as having CDL or driver’s license.": "Ningún miembro de la tripulación tiene licencia de conducir (CDL) listada",
    "ACE ID specified for crewmember is not pre-registered in carrier’s account.": "El ACE ID especificado para el miembro de la tripulación no está pre-registrado en la cuenta del transportista",
    "Gender code is missing or other than ‘M’/’F’.": "El código de género falta o es diferente a ‘M’/’F’",
    "Insurance information present, Hazmat endorsement missing": "Información de seguro presente, falta endoso de materiales peligrosos",
    "Hazmat contact missing": "Falta contacto de materiales peligrosos",
    "An internal error has occurred in processing": "Ha ocurrido un error interno en el procesamiento",
    "Trip number missing or invalid": "Número de viaje faltante o inválido",
    "Trip number reused within a specified time period: 1 year for preferred, 1 day for standard; ": "Número de viaje reutilizado dentro del período especificado: 1 año para preferente, 1 día para estándar",
    "SCAC not valid or doesn’t Exist": "SCAC no válido o no existe",
    "Preferred manifest,registered conveyance no transponder in conveyance profile.": "Manifiesto preferente, medio de transporte registrado sin transpondedor en el perfil",
    "Combination of state/province and country is not correct for shipment and party type": "La combinación de estado/provincia y país no es correcta para el envío y tipo de parte",
    "SCAC not valid or doesn’t exist": "SCAC no válido o no existe",
    "Preferred manifest – release type not specified FUTURE USE": "Manifiesto preferente – tipo de liberación no especificado USO FUTURO",
    "Amendment code doesn’t exist for trip use": "El código de enmienda no existe para uso en viajes",
    "UN code specified is incorrect or doesn’t exist": "El código UN especificado es incorrecto o no existe",
    "Party type specified not in list": "El tipo de parte especificado no está en la lista",
    "Broker filer code specified doesn’t exist or is incorrect": "El código de agente aduanal especificado no existe o es incorrecto",
    "Shipper indicated is not C-TPAT per account records": "El embarcador indicado no es C-TPAT según registros de cuenta",
    "update of manifest – trip specified doesn’t exist": "actualización de manifiesto – el viaje especificado no existe",
    "Either equipment number or license plate required for trip": "Se requiere número de equipo o placa para el viaje",
    "Qualifier not specified in this element": "Calificador no especificado en este elemento",
    "Amendment code missing after ‘manifest complete’ message;": "Código de enmienda faltante después del mensaje ‘manifiesto completo’",
    "Duns number specified doesn’t exist or is invalid": "El número DUNS especificado no existe o es inválido",
    "Party specified does not exist or is invalid per carrier account records": "La parte especificada no existe o es inválida según registros de cuenta del transportista",
    "Preferred shipment, ACE ID doesn’t exist or is invalid per carrier account records": "Envío preferente, el ACE ID no existe o es inválido según registros de cuenta del transportista",
    "License plate data missing": "Datos de placa faltantes",
    "The in-bond number specified has no associated shipments": "El número in-bond especificado no tiene envíos asociados",
    "Total of boarded quantities in split shipment is greater than original manifested quantity for bill": "El total de cantidades embarcadas en envío dividido es mayor que la cantidad manifestada original para el conocimiento",
    "Carrier attempts to create a split shipment but shipment release type will not allow splits.": "El transportista intenta crear un envío dividido pero el tipo de liberación no permite divisiones",
    "Type specified doesn’t exist or is invalid.": "El tipo especificado no existe o es inválido",
    "Combination of state/province and country is not correct.": "La combinación de estado/provincia y país no es correcta",
    "IIT code doesn’t exist or is invalid.": "El código IIT no existe o es inválido",
    "Address specified for crew is not US address.": "La dirección especificada para la tripulación no es una dirección de EE.UU",
    "ZIP code specified for crew is not US ZIP code": "El código postal especificado para la tripulación no es un código postal de EE.UU",
    "Code specified for crew travel document does not exist or is invalid.": "El código especificado para documento de viaje de tripulación no existe o es inválido",
    "State/Province code specified does not match country code other than US, MX, CA.": "El código de estado/provincia especificado no coincide con el código de país (diferente a US, MX, CA)",
    "Conveyance type code specified does not exist or is invalid.": "El código de tipo de medio de transporte especificado no existe o es inválido",
    "VIN number/transponder number missing.": "Número VIN/número de transpondedor faltante",
    "Complete crew information missing.": "Información completa de tripulación faltante",
    "Complete crew Information not filed for trip.": "Información completa de tripulación no presentada para el viaje",
    "Country code Specified does not exist or is invalid.": "El código de país especificado no existe o es inválido",
    "Equipment license plate is missing or invalid.": "La placa del equipo falta o es inválida",
    "Sec 321 entry, country code specified does not exist or is invalid": "Entrada Sec 321, el código de país especificado no existe o es inválido",
    "If the shipment is preferred the estimated port of departure is anything other than Schedule K code.": "Si el envío es preferente, el puerto estimado de salida es diferente al código Schedule K",
    "Preferred shipment and importer not CTPAT approved as per account records.": "Envío preferente e importador no aprobados CTPAT según registros de cuenta",
    "IIT code is anything other than C,I, A, B": "El código IIT es diferente a C, I, A, B",
    "Create date is more than 90 days in advance of estimated arrival date.": "La fecha de creación es más de 90 días anterior a la fecha estimada de llegada",
    "Sum of all boarded quantities from all trips is greater than total shipment quantity.": "La suma de todas las cantidades embarcadas de todos los viajes es mayor que la cantidad total del envío",
    "Same seal numbers specified for multiple equipment": "Mismos números de precinto especificados para múltiples equipos",
    "FDA confirmation code is missing or is invalid": "El código de confirmación FDA falta o es inválido",
    "Preliminary 309 bills translated with an equipment number that is not duplicated in the 358 consist": "Conocimientos preliminares 309 traducidos con un número de equipo que no está duplicado en el consist 358",
    "The conveyance/equipment ACE ID specified is not registered to the carrier": "El ACE ID del medio de transporte/equipo especificado no está registrado al transportista",
    "Value of commodity is greater than $200": "El valor de la mercancía es mayor a $200",
    "FAST number specified is registered in FAST system to different carrier.": "El número FAST especificado está registrado en sistema FAST a un transportista diferente",
    "Missing entity identifier code and/or name.": "Falta código identificador de entidad y/o nombre",
    "A shipment designated as ‘preferred’ missing shipment records, cannot be empty FUTURE USE": "Un envío designado como ‘preferente’ falta registros de envío, no puede estar vacío USO FUTURO",
    "Carrier attached a preferred bill to a standard manifest FUTURE USE": "Transportista adjuntó un conocimiento preferente a un manifiesto estándar USO FUTURO",
    "Proximity card, travel document number, FAST ID not in account or duplicate.": "Tarjeta de proximidad, número de documento de viaje, FAST ID no en cuenta o duplicado",
    "2 different types of releases in same shipment: BRASS, inbond": "2 tipos diferentes de liberación en el mismo envío: BRASS, in-bond",
    "Shipment data is part of another manifest and linking is not allowed": "Los datos del envío son parte de otro manifiesto y no se permite la vinculación",
    "Format isn’t alphanumeric without spaces for shipment.": "El formato no es alfanumérico sin espacios para el envío",
    "Format isn’t alphanumeric without spaces in between": "El formato no es alfanumérico sin espacios intermedios",
    "Duplicate license plate for trip or shipment.": "Placa duplicada para viaje o envío",
    "Duplicate equipment for trip or shipment: equipment number is repeated on same shipment or trip.": "Equipo duplicado para viaje o envío: número de equipo repetido en el mismo envío o viaje",
    "Duplicate trip party for trip: 2 parties with the same details": "Parte de viaje duplicada: 2 partes con los mismos detalles",
    "Mandatory crew information is not filed for crew: last name, first name, DOB.": "Información obligatoria de tripulación no presentada: apellido, nombre, fecha de nacimiento",
    "Invalid filing status to update the trip: attempting to file amendment codes on preliminary bills.": "Estado de presentación inválido para actualizar el viaje: intento de presentar códigos de enmienda en conocimientos preliminares",
    "Number exceeds 10 positions.": "El número excede 10 posiciones",
    "Number exceeds 8 positions.": "El número excede 8 posiciones",
    "Expected port of arrival changed to anything other than actual port of arrival after arrival of conveyance.": "Puerto esperado de llegada cambiado a uno diferente al puerto real de llegada después de la llegada del medio de transporte",
    "Preferred manifest not allowed for carrier Carrier not permitted for FAST.": "Manifiesto preferente no permitido para transportista. Transportista no autorizado para FAST",
    "No ACE ID or CDL provided for at least 1 crewmember.": "No se proporcionó ACE ID o CDL para al menos 1 miembro de la tripulación",
    "Carrier registered for trip not C-TPAT in account.": "Transportista registrado para viaje no es C-TPAT en la cuenta",
    "Required trip information missing for trip: date,time.": "Información requerida de viaje faltante: fecha, hora",
    "Required information for complete manifest missing: trip, crew, conveyance, equipment, shipments.": "Información requerida para manifiesto completo faltante: viaje, tripulación, medio de transporte, equipo, envíos",
    "Party data not provided for the shipment.": "Datos de parte no proporcionados para el envío",
    "Complete manifest code ‘W’ In M1009 has shipments rejected: need bill corrected, retransmitted, and 353 set to confirm manifest is complete.": "El código de manifiesto completo ‘W’ en M1009 tiene envíos rechazados: necesita conocimiento corregido, retransmitido, y 353 configurado para confirmar que el manifiesto está completo",
    "Estimated date of Departure for in-bond shipment where M1201 is 62 or 63 is invalid or blank": "Fecha estimada de salida para envío in-bond donde M1201 es 62 o 63 es inválida o está en blanco",
    "Code is ‘W’ for complete manifest, but M1005 has ‘system’ not trip Number": "El código es ‘W’ para manifiesto completo, pero M1005 tiene ‘system’ no número de viaje",
    "This error message is returned after there have been errors in over 100 shipments. It is a warning message intended for the sender to check all of his shipments. ACE stops processing errors after 100 shipments Normally this occurs when one or more errors are present in each shipment. The sender is highly encouraged to look at all shipments for similar errors.": "Este mensaje de error se devuelve después de que ha habido errores en más de 100 envíos. Es un mensaje de advertencia para que el remitente revise todos sus envíos. ACE deja de procesar errores después de 100 envíos. Normalmente esto ocurre cuando uno o más errores están presentes en cada envío. Se recomienda encarecidamente al remitente revisar todos los envíos en busca de errores similares",
    "Sender attempts to delete a manifest after conveyance has been arrived at the first US port.": "El remitente intenta eliminar un manifiesto después de que el medio de transporte ha llegado al primer puerto de EE.UU",
    "The transmitter ID in ISA06, either SCAC or mutually defined ID, is not configured in ACE": "El ID del transmisor en ISA06, ya sea SCAC o ID definido mutuamente, no está configurado en ACE",
    "Preparer ID not configured in ACE": "ID del preparador no configurado en ACE",
    "A profile has been set up in ACE for the preparer but the transmitter’s account does not reference the preparer.": "Se ha configurado un perfil en ACE para el preparador pero la cuenta del transmisor no referencia al preparador",
    "Even though a proper EDI profile has been set up for both transmitter and preparer, transmitter is not authorized to send.": "Aunque se ha configurado un perfil EDI adecuado tanto para el transmisor como para el preparador, el transmisor no está autorizado para enviar",
    "Self preparer flag not set in transmitter’s profile.": "Indicador de auto-preparador no configurado en el perfil del transmisor",
    "Transmitter sends in manifest before authorized startup date in production": "El transmisor envía manifiesto antes de la fecha de inicio autorizada en producción",
    "Date is over 45 days from date of expected reimportation into US": "La fecha excede 45 días desde la fecha esperada de reimportación a EE.UU",
    "Code ‘N’ is supplied": "El código ‘N’ es proporcionado",
    "SCAC/trip number in M10 of 353 set, BGM of CUSCAR doesn’t match the SCAC/trip number of the original M10 of 309, BGM of CUSCAR.": "El número SCAC/viaje en M10 del conjunto 353, BGM de CUSCAR no coincide con el número SCAC/viaje del M10 original de 309, BGM de CUSCAR",
    "358 set M7 segment is provided after VEH or VID segments": "El segmento M7 del conjunto 358 se proporciona después de los segmentos VEH o VID",
    "Carrier has an invalid address in ACE profile.": "El transportista tiene una dirección inválida en el perfil de ACE",
    "M1002 anything other than ‘J’": "M1002 diferente a ‘J’",
    "Changing codes ‘61’,’62’,’63’": "Cambiando códigos ‘61’,’62’,’63’",
    "Carrier attempts to arrive inbond by container/equipment in one destination port but inbond-bills associated with the container/equipment are for various destination ports. To arrive by container equipment all inbond-bills must be for the same destination port in which the container/equipment is arrived.": "El transportista intenta registrar llegada de in-bond por contenedor/equipo en un puerto de destino pero los conocimientos in-bond asociados con el contenedor/equipo son para varios puertos de destino. Para registrar llegada por contenedor/equipo, todos los conocimientos in-bond deben ser para el mismo puerto de destino en el que se registra la llegada del contenedor/equipo",
    "Carrier attempts to export inbond by container/equipment in one destination port but inbond-bills associated with the container/equipment are for various destination ports. To arrive by container equipment all inbond-bills must be for the same destination port in which the container/equipment is arrived.": "El transportista intenta exportar in-bond por contenedor/equipo en un puerto de destino pero los conocimientos in-bond asociados con el contenedor/equipo son para varios puertos de destino. Para exportar por contenedor/equipo, todos los conocimientos in-bond deben ser para el mismo puerto de destino",
    "Carrier attempts to export inbond by inbond number, bill of lading number, or container-equipment number but (1) the inbond has not been arrived at the destination inbond port or (2) the inbond has been arrived but a hold exists on a bill associated with the inbond .(3) the inbond has already been exported.": "El transportista intenta exportar in-bond por número in-bond, número de conocimiento, o número de contenedor-equipo pero (1) el in-bond no ha llegado al puerto de destino, (2) el in-bond ha llegado pero existe una retención en un conocimiento asociado, (3) el in-bond ya ha sido exportado",
    "Carrier attempts to cancel arrival/export inbond by inbond number, bill of lading number, or container-equipment number but (1) the inbond has not been arrived at the destination inbond port or (2) the inbond has been arrived but a hold exists on a bill associated with the inbond .(3) the inbond has already been cancelled.": "El transportista intenta cancelar llegada/exportación de in-bond por número in-bond, número de conocimiento, o número de contenedor-equipo pero (1) el in-bond no ha llegado al puerto de destino, (2) el in-bond ha llegado pero existe una retención en un conocimiento asociado, (3) el in-bond ya ha sido cancelado",
    "Citizenship code and country code are missing.": "El código de ciudadanía y el código de país faltan",
    "Document code and document cited are not WHTI certified.": "El código de documento y el documento citado no están certificados WHTI",
    "The segment identifier is not recognized as a valid segment within the transaction set.": "El identificador de segmento no es reconocido como válido dentro del conjunto de transacciones",
    "The segment was encountered in a location where it is not expected according to the transaction set structure.": "El segmento se encontró en una ubicación donde no se espera según la estructura del conjunto de transacciones",
    "A required segment defined as mandatory in the transaction set structure is missing.": "Falta un segmento requerido definido como obligatorio en la estructura del conjunto de transacciones",
    "A loop within the transaction set appears more times than the maximum allowed occurrences.": "Un bucle dentro del conjunto de transacciones aparece más veces que el máximo permitido",
    "The segment appears more times than the maximum number of uses allowed in the transaction set.": "El segmento aparece más veces que el número máximo de usos permitido en el conjunto de transacciones",
    "The segment is not defined as part of the transaction set structure.": "El segmento no está definido como parte de la estructura del conjunto de transacciones",
    "The segment appears in an incorrect order relative to the defined transaction set sequence.": "El segmento aparece en un orden incorrecto con respecto a la secuencia definida del conjunto de transacciones",
    "One or more data elements within the segment contain validation errors.": "Uno o más elementos de datos dentro del segmento contienen errores de validación",
    "The segment contains extra trailing delimiters indicating empty or undefined data elements.": "El segmento contiene delimitadores finales extra que indican elementos de datos vacíos o no definidos",
    "A required data element defined as mandatory in the implementation guide is missing from the segment.": "Falta un elemento de datos requerido definido como obligatorio en la guía de implementación",
    "A conditionally required data element is missing when the condition that makes it required has been met.": "Falta un elemento de datos condicionalmente requerido cuando se ha cumplido la condición que lo hace requerido",
    "The segment contains more data elements than the maximum number allowed.": "El segmento contiene más elementos de datos que el número máximo permitido",
    "The value of the data element is shorter than the minimum length allowed.": "El valor del elemento de datos es más corto que la longitud mínima permitida",
    "The value of the data element exceeds the maximum allowed length.": "El valor del elemento de datos excede la longitud máxima permitida",
    "The data element contains one or more characters that are not valid according to the allowed character set.": "El elemento de datos contiene uno o más caracteres no válidos según el conjunto de caracteres permitido",
    "The value provided is not a valid code defined for this data element.": "El valor proporcionado no es un código válido definido para este elemento de datos",
    "The date value is not in the expected format or represents an invalid calendar date.": "El valor de fecha no está en el formato esperado o representa una fecha de calendario inválida",
    "The time value is not in the expected format or represents an invalid time.": "El valor de hora no está en el formato esperado o representa una hora inválida",
    "Two or more data elements that are mutually exclusive were provided together.": "Se proporcionaron juntos dos o más elementos de datos mutuamente excluyentes",
    "The number of repeated data elements exceeds the maximum number allowed.": "El número de elementos de datos repetidos excede el máximo permitido",
    "A composite data element contains more component elements than allowed.": "Un elemento de datos compuesto contiene más elementos componentes de lo permitido",
    "The composite data element contains extra trailing delimiters that indicate empty or undefined component elements.": "El elemento de datos compuesto contiene delimitadores finales extra que indican elementos componentes vacíos o no definidos",
    "The transaction set was received and processed successfully without any errors.": "El conjunto de transacciones se recibió y procesó exitosamente sin errores",
    "The transaction set was accepted and processed, but one or more errors or warnings were identified during validation.": "El conjunto de transacciones se aceptó y procesó, pero se identificaron uno o más errores o advertencias durante la validación",
    "The transaction set was rejected due to errors that prevented it from being processed.": "El conjunto de transacciones fue rechazado debido a errores que impidieron su procesamiento",
    "The received transaction set type is not supported by the trading partner or system.": "El tipo de conjunto de transacciones recibido no es compatible con el socio comercial o el sistema",
    "The transaction set trailer segment (SE) is missing from the received transaction set.": "El segmento final del conjunto de transacciones (SE) falta en el conjunto de transacciones recibido",
    "The control number in the transaction set header (ST) does not match the control number in the transaction set trailer (SE).": "El número de control en el encabezado del conjunto de transacciones (ST) no coincide con el número de control en el final del conjunto de transacciones (SE)",
    "The segment count specified in the transaction set trailer does not match the actual number of segments received.": "El número de segmentos especificado en el final del conjunto de transacciones no coincide con el número real de segmentos recibidos",
    "One or more segments within the transaction set contain errors.": "Uno o más segmentos dentro del conjunto de transacciones contienen errores",
    "The transaction set identifier in the header segment is missing or invalid.": "El identificador del conjunto de transacciones en el segmento de encabezado falta o es inválido",
    "The transaction set control number in the header is missing or invalid.": "El número de control del conjunto de transacciones en el encabezado falta o es inválido",
    "The authentication key name provided in the message is not recognized.": "El nombre de la clave de autenticación proporcionada en el mensaje no es reconocido",
    "The encryption key name provided in the message is not recognized.": "El nombre de la clave de cifrado proporcionada en el mensaje no es reconocido",
    "The requested security service such as authentication or encryption is not available or supported.": "El servicio de seguridad solicitado como autenticación o cifrado no está disponible o no es compatible",
    "The specified security recipient is not recognized by the receiving system.": "El destinatario de seguridad especificado no es reconocido por el sistema receptor",
    "The message length is incorrect for encrypted content.": "La longitud del mensaje es incorrecta para contenido cifrado",
    "The message authentication code validation failed, indicating the message integrity cannot be verified.": "Falló la validación del código de autenticación del mensaje, indicando que no se puede verificar la integridad del mensaje",
    "The specified security originator is not recognized by the receiving system.": "El originador de seguridad especificado no es reconocido por el sistema receptor",
    "A syntax error was detected in the decrypted message content.": "Se detectó un error de sintaxis en el contenido del mensaje descifrado",
    "The security mechanism used in the message is not supported by the receiving system.": "El mecanismo de seguridad utilizado en el mensaje no es compatible con el sistema receptor",
    "The transaction set was received outside of a valid functional group (GS/GE).": "El conjunto de transacciones se recibió fuera de un grupo funcional válido (GS/GE)",
    "The implementation convention reference for the transaction set is invalid or not recognized.": "La referencia de convención de implementación para el conjunto de transacciones es inválida o no reconocida",
    "The transaction set control number is duplicated within the same functional group.": "El número de control del conjunto de transacciones está duplicado dentro del mismo grupo funcional",
    "The S3S security start segment is present but the corresponding S3E security end segment is missing.": "El segmento de inicio de seguridad S3S está presente pero falta el segmento final de seguridad S3E correspondiente",
    "The S3E security end segment is present but the corresponding S3S security start segment is missing.": "El segmento final de seguridad S3E está presente pero falta el segmento de inicio de seguridad S3S correspondiente",
    "The S4S security start segment is present but the corresponding S4E security end segment is missing.": "El segmento de inicio de seguridad S4S está presente pero falta el segmento final de seguridad S4E correspondiente",
    "The S4E security end segment is present but the corresponding S4S security start segment is missing.": "El segmento final de seguridad S4E está presente pero falta el segmento de inicio de seguridad S4S correspondiente",
    "The interchange was received and accepted without any detected errors.": "El intercambio se recibió y aceptó sin errores detectados",
    "The interchange was accepted, but one or more errors were detected during validation.": "El intercambio se aceptó, pero se detectaron uno o más errores durante la validación",
    "The interchange was rejected because the message authentication code validation failed.": "El intercambio fue rechazado porque falló la validación del código de autenticación del mensaje",
    "The interchange was partially accepted, but at least one transaction set within it was rejected.": "El intercambio fue parcialmente aceptado, pero al menos un conjunto de transacciones dentro de él fue rechazado",
    "The interchange was rejected due to errors that prevented it from being accepted.": "El intercambio fue rechazado debido a errores que impidieron su aceptación",
    "The interchange was rejected because security assurance or validity checks failed.": "El intercambio fue rechazado porque fallaron las comprobaciones de seguridad o validez",
    "The interchange was rejected because the decrypted content could not be properly analyzed or validated.": "El intercambio fue rechazado porque el contenido descifrado no pudo ser analizado o validado correctamente",
    "The functional group type is not supported by the receiving system.": "El tipo de grupo funcional no es compatible con el sistema receptor",
    "The version of the functional group specified in the header is not supported.": "La versión del grupo funcional especificada en el encabezado no es compatible",
    "The functional group trailer segment (GE) is missing from the interchange.": "El segmento final del grupo funcional (GE) falta en el intercambio",
    "The group control number in the functional group header (GS) does not match the control number in the trailer (GE).": "El número de control del grupo en el encabezado del grupo funcional (GS) no coincide con el número de control en el final (GE)",
    "The number of transaction sets specified in the functional group trailer does not match the actual number received.": "El número de conjuntos de transacciones especificado en el final del grupo funcional no coincide con el número real recibido",
    "The group control number does not conform to the required syntax rules.": "El número de control del grupo no cumple con las reglas de sintaxis requeridas",
    "No B01/M11 Record Found": "No se encontró registro B01/M11",
    "Invalid U01/N1 or N01/N1": "U01/N1 o N01/N1 inválido",
    "Invalid Carrier Code": "Código de transportista inválido",
    "Missing or Invalid Bill": "Conocimiento faltante o inválido",
    "Invalid Weight": "Peso inválido",
    "Invalid Weight Unit": "Unidad de peso inválida",
    "Invalid Inbond Number": "Número de in-bond inválido",
    "Invalid DDPP": "DDPP inválido",
    "Invalid Foreign Port": "Puerto extranjero inválido",
    "B/L Already on File": "Conocimiento ya existe en archivo",
    "Invalid Quantity": "Cantidad inválida",
    "Invalid Amendment Code": "Código de enmienda inválido",
    "Missing Description": "Descripción faltante",
    "Invalid Estimated Arrival Date": "Fecha estimada de llegada inválida",
    "Bill Rejected": "Conocimiento rechazado",
    "Incorrect Harmonized #": "Número armonizado incorrecto",
    "Manifest Transmittal": "Transmisión de manifiesto",
    "Not Authorized to Transmit": "No autorizado para transmitir",
    "Entity already arrived": "Entidad ya llegada",
    "FIRMS Code not on File": "Código FIRMS no existe en archivo",
    "Invalid Manifest Type Code": "Código de tipo de manifiesto inválido",
    "No Man Unit Code for BL": "Sin código de unidad de manifiesto para conocimiento",
    "BL not on File or Deleted": "Conocimiento no existe en archivo o fue eliminado",
    "Invalid Est Arr Time": "Hora estimada de llegada inválida",
    "C4 Code not Valid": "Código C4 no válido",
    "Invalid Pedimento Number": "Número de pedimento inválido",
    "Inv Conv ACE ID": "ID de medio de transporte ACE inválido",
    "Inv Lic Plate State for Trip": "Estado de placa inválido para viaje",
    "Missing Lic Plate Country": "País de placa faltante",
    "Inv Lic Plat Country for Trip": "País de placa inválido para viaje",
    "Invalid Conv Code": "Código de medio de transporte inválido",
    "Ins Info Incomplete": "Información de seguro incompleta",
    "Ins Info not Maintained": "Información de seguro no mantenida",
    "No Person in Charge": "Sin persona encargada",
    "No Driver CDL/Lic for Trip": "Sin licencia/CDL de conductor para viaje",
    "Crew ACE ID not for Carr": "ACE ID de tripulación no corresponde al transportista",
    "No Gender Code": "Sin código de género",
    "No Hazmat Endorse for Crew": "Sin endoso de materiales peligrosos para tripulación",
    "No Hazmat Contact": "Sin contacto de materiales peligrosos",
    "Int Error – Take no Action": "Error interno - No tomar acción",
    "Trip Number Required": "Número de viaje requerido",
    "Duplicate Trip Number": "Número de viaje duplicado",
    "Invalid SCAC on Trip Number": "SCAC inválido en número de viaje",
    "No Transp on Conv for Trip": "Sin transpondedor en medio de transporte para viaje",
    "Inv Combination for Trip": "Combinación inválida para viaje",
    "Inv SCAC on Shipment": "SCAC inválido en envío",
    "No Shipment Rel Type Filed": "Tipo de liberación de envío no presentado",
    "Inv Amend Code for Trip": "Código de enmienda inválido para viaje",
    "Inv UN Danger Goods Code": "Código UN de mercancías peligrosas inválido",
    "Inv Shipment Party Type": "Tipo de parte de envío inválido",
    "Inv Filer Code for Shipment": "Código de declarante inválido para envío",
    "Pref not allowed for Imp": "Preferente no permitido para importador",
    "Trip Number does not Exist": "El número de viaje no existe",
    "Inv Equip Identifier for Trip": "Identificador de equipo inválido para viaje",
    "Inv Party Type,ID and Comb": "Tipo de parte, ID y combinación inválidos",
    "Amend Code not Filed": "Código de enmienda no presentado",
    "Inv DUNS Number": "Número DUNS inválido",
    "Inv Trip Party ACE ID": "ACE ID de parte de viaje inválido",
    "Inv Shipment Party ACE ID": "ACE ID de parte de envío inválido",
    "Conv Lic Plate Data Missing": "Datos de placa de medio de transporte faltantes",
    "Shipment not found for IB": "Envío no encontrado para in-bond",
    "Brd Qty Grtr than Shp Qty": "Cantidad embarcada mayor que cantidad de envío",
    "Inv Split of Shipment": "División de envío inválida",
    "Inv Equipment Type": "Tipo de equipo inválido",
    "Inv Lic Plate Comb for Shp": "Combinación de placa inválida para envío",
    "Inv IIT Code for Trip": "Código IIT inválido para viaje",
    "Inv Party ST for Trip": "Estado de parte inválido para viaje",
    "Inv Party ZIP for Trip": "Código postal de parte inválido para viaje",
    "Inv Travel Doc type on Trip": "Tipo de documento de viaje inválido en viaje",
    "Inv Travl Doc St/Ctry Com": "Combinación estado/país de documento de viaje inválida",
    "Inv Conv Type for Trip": "Tipo de medio de transporte inválido para viaje",
    "Req Conveyance Info Missing": "Información requerida de medio de transporte faltante",
    "EQ Lic Plate/Number Missing": "Placa/número de equipo faltante",
    "Comp Crew Info not Filed": "Información completa de tripulación no presentada",
    "Missing Complete Crew Info": "Información completa de tripulación faltante",
    "No Travel Doc for Crew": "Sin documento de viaje para tripulación",
    "Inv Travel Doc Ctry": "País de documento de viaje inválido",
    "Equip Lic Plate Missing": "Placa de equipo faltante",
    "Inv Ctry of Orig for Shp": "País de origen inválido para envío",
    "For Port must be Sch K": "Puerto extranjero debe ser Schedule K",
    "Imp not CTPAT for Pref": "Importador no es CTPAT para preferente",
    "Inv Equip IIT Code for Trip": "Código IIT de equipo inválido para viaje",
    "Man Com Dt not Allowed": "Fecha de manifiesto completo no permitida",
    "Brd Qty Sum Grtr Shp Qty": "Suma de cantidades embarcadas mayor que cantidad de envío",
    "Inv Seal # Duplicate for Trip": "Número de precinto duplicado para viaje",
    "No FDA Conf in TE": "Sin confirmación FDA en TE",
    "Inv IIT Code for Ship": "Código IIT inválido para envío",
    "Mismatch of Equip Data": "Discrepancia en datos de equipo",
    "Conv/Equip ACE ID not for Carr": "ACE ID de medio de transporte/equipo no corresponde al transportista",
    "Inv Amount for Sec 321": "Monto inválido para Sección 321",
    "Inv FAST Number": "Número FAST inválido",
    "Missing Req Ship Party Data": "Datos requeridos de parte de envío faltantes",
    "No empty Shipments in Pref": "No hay envíos vacíos en preferente",
    "Inv Link of Man Type for Trip": "Vinculación de tipo de manifiesto inválida para viaje",
    "Inv Travel Doc Number": "Número de documento de viaje inválido",
    "Ship Data Mixed with Rel Types": "Datos de envío mezclados con tipos de liberación",
    "Shipment on Another Manifest": "Envío en otro manifiesto",
    "Inv Format for Shipment": "Formato inválido para envío",
    "INV Format for Manifest": "Formato inválido para manifiesto",
    "Duplicate License Plate": "Placa duplicada",
    "Duplicate Equipment": "Equipo duplicado",
    "Duplicate Trip Party": "Parte de viaje duplicada",
    "Missing Mand Crew Info": "Información obligatoria de tripulación faltante",
    "Invalid Filing Status": "Estado de presentación inválido",
    "Inv License Plate Number": "Número de placa inválido",
    "Inv DOT Number": "Número DOT inválido",
    "Expected Port cant be Changed": "El puerto esperado no puede ser cambiado",
    "Pref Manifest not Allowed": "Manifiesto preferente no permitido",
    "No ACE ID or CDL Provided": "No se proporcionó ACE ID o CDL",
    "Carrier not C-TPAT": "Transportista no es C-TPAT",
    "Required Trip Info Missing": "Información requerida de viaje faltante",
    "Manifest Rejected": "Manifiesto rechazado",
    "Req Ship Party not Given": "Parte requerida de envío no proporcionada",
    "Man Returned to Preliminary": "Manifiesto devuelto a preliminar",
    "Inv Est Date of US Exit": "Fecha estimada de salida de EE.UU. inválida",
    "Mismatch of Codes at Trip": "Discrepancia de códigos en viaje",
    "Errors on more than 100 SCN": "Errores en más de 100 números de control de envío",
    "Man Arrivd Cant be Cancelld": "Manifiesto llegado no puede ser cancelado",
    "Trans ID not in ACE as SCAC": "ID de transmisor no está en ACE como SCAC",
    "Prep ID nor in ACE as SCAC": "ID de preparador no está en ACE como SCAC",
    "Trans ID has no EDI Profile": "ID de transmisor no tiene perfil EDI",
    "No Trans/Prep Relationship": "Sin relación transmisor/preparador",
    "Trans also Preparer": "Transmisor también es preparador",
    "Msg Typ not allowed for Prod": "Tipo de mensaje no permitido para producción",
    "US Export Date over 45 Days": "Fecha de exportación de EE.UU. excede 45 días",
    "Carr/Customs Custody eq N": "Custodia transportista/aduanas es N",
    "Incorrect SCAC/TRIP": "SCAC/VIAJE incorrecto",
    "Seal Numbers in Delink": "Números de precinto en desvinculación",
    "Inv Address in Profile": "Dirección inválida en perfil",
    "Invalid MOT": "Medio de transporte inválido",
    "No Ent Type Change for Inb": "Sin cambio de tipo de entrada para in-bond",
    "No Cn Arr if Mult Dest IB": "No se puede llegar contenedor si in-bond multi-destino",
    "No Cn Exp If Mult Dest IB": "No se puede exportar contenedor si in-bond multi-destino",
    "Inbond Export Rej": "Exportación de in-bond rechazada",
    "Inbond Cancel Rej": "Cancelación de in-bond rechazada",
    "MAN OR ACCNT MISS CIT CODE": "Manifiesto o cuenta sin código de ciudadanía",
    "MAN OR ACCNT MISS WHTI DOCS": "Manifiesto o cuenta sin documentos WHTI",

    "Unrecognized segment ID": "ID de segmento no reconocido",
    "Unexpected segment": "Segmento inesperado",
    "Mandatory segment missing": "Segmento obligatorio faltante",
    "Loop Occurs Over Maximum Times": "Bucle excede el máximo de veces",
    "Segment Exceeds Maximum Use": "Segmento excede el uso máximo",
    "Segment Not in Defined Transaction Set": "Segmento no está en el conjunto de transacciones definido",
    "Segment Not in Proper Sequence": "Segmento fuera de secuencia",
    "Segment Has Data Element Errors": "Segmento tiene errores en elementos de datos",
    "Segment Has Excess Trailing Delimiters": "Segmento tiene delimitadores finales excesivos",
    "Mandatory data element missing": "Elemento de dato obligatorio faltante",
    "Conditional required data element missing": "Elemento de dato condicional requerido faltante",
    "Too many data elements": "Demasiados elementos de datos",
    "Data element too short": "Elemento de dato demasiado corto",
    "Data element too long": "Elemento de dato demasiado largo",
    "Invalid character in data element": "Carácter inválido en elemento de dato",
    "Invalid code value": "Valor de código inválido",
    "Invalid Date": "Fecha inválida",
    "Invalid Time": "Hora inválida",
    "Exclusion Condition Violated": "Condición de exclusión violada",
    "Too Many Repetitions": "Demasiadas repeticiones",
    "Too Many Components": "Demasiados componentes",
    "Composite Data Structure Contains Excess Trailing Delimiters": "Estructura de dato compuesto contiene delimitadores finales excesivos",
    "Accepted": "Aceptado",
    "Accepted But Errors Were Noted": "Aceptado pero se notaron errores",
    "Rejected": "Rechazado",
    "Transaction Set Not Supported": "Conjunto de transacciones no soportado",
    "Transaction Set Trailer Missing": "Falta finalizador del conjunto de transacciones",
    "Transaction Set Control Number in Header and Trailer Do Not Match": "Número de control en cabecera y finalizador no coinciden",
    "Number of Included Segments Does Not Match Actual Count": "Número de segmentos incluidos no coincide con el conteo real",
    "One or More Segments in Error": "Uno o más segmentos en error",
    "Missing or Invalid Transaction Set Identifier": "Identificador de conjunto de transacciones faltante o inválido",
    "Missing or Invalid Transaction Set Control Number": "Número de control de conjunto de transacciones faltante o inválido",
    "Authentication Key Name Unknown": "Nombre de clave de autenticación desconocido",
    "Encryption Key Name Unknown": "Nombre de clave de cifrado desconocido",
    "Requested Service (Authentication or Encrypted) Not Available": "Servicio solicitado (autenticación o cifrado) no disponible",
    "Unknown Security Recipient": "Destinatario de seguridad desconocido",
    "Incorrect Message Length (Encryption Only)": "Longitud de mensaje incorrecta (solo cifrado)",
    "Message Authentication Code Failed": "Código de autenticación de mensaje falló",
    "Unknown Security Originator": "Originador de seguridad desconocido",
    "Syntax Error in Decrypted Text": "Error de sintaxis en texto descifrado",
    "Security Not Supported": "Seguridad no soportada",
    "Transaction Set not in Functional Group": "Conjunto de transacciones no está en grupo funcional",
    "Invalid Transaction Set Implementation Convention Reference": "Referencia de convención de implementación inválida",
    "Transaction Set Control Number Not Unique within the Functional Group": "Número de control no es único dentro del grupo funcional",
    "S3E Security End Segment Missing for S3S Security Start Segment": "Segmento final de seguridad S3E faltante para segmento inicial S3S",
    "S3S Security Start Segment Missing for S3E Security End Segment": "Segmento inicial de seguridad S3S faltante para segmento final S3E",
    "S4E Security End Segment Missing for S4S Security Start Segment": "Segmento final de seguridad S4E faltante para segmento inicial S4S",
    "S4S Security Start Segment Missing for S4E Security End Segment": "Segmento inicial de seguridad S4S faltante para segmento final S4E",
    "Accepted, But Errors Were Noted": "Aceptado, pero se notaron errores",
    "Rejected, Message Authentication Code (MAC) Failed": "Rechazado, código de autenticación de mensaje (MAC) falló",
    "Partially Accepted, At Least One Transaction Set Was Rejected": "Parcialmente aceptado, al menos un conjunto de transacciones fue rechazado",
    "Rejected, Assurance Failed Validity Tests": "Rechazado, aseguramiento falló pruebas de validez",
    "Rejected, Content After Decryption Could Not Be Analyzed": "Rechazado, contenido después del descifrado no pudo ser analizado",
    "Functional Group Not Supported": "Grupo funcional no soportado",
    "Functional Group Version Not Supported": "Versión de grupo funcional no soportada",
    "Functional Group Trailer Missing": "Finalizador de grupo funcional faltante",
    "Group Control Number in the Functional Group Header and Trailer Do Not Agree": "Número de control en cabecera y finalizador de grupo funcional no coinciden",
    "Number of Included Transaction Sets Does Not Match Actual Count": "Número de conjuntos de transacciones incluidos no coincide con el conteo real",
    "Group Control Number Violates Syntax": "Número de control de grupo viola sintaxis",
    "Invalid Cargo Description. Please enter a specific mechandise description.": "Descripción de mercancía inválida. Por favor ingrese una descripción específica de la mercancía.",
    "View only access": "Acceso de solo lectura. No puede editar ni enviar viajes.",
    "Allows access to edit catalogs": "Permite el acceso para editar catálogos.",
    "Limits visibility to own trips only": "Limita la visibilidad únicamente a sus propios viajes.",
    "Read Only": "Solo lectura",
    "Catalog Edition": "Edición catálogos",
    "Restricted": "Reestringido"
}

export default data;